import { hAppEnum } from "../types/enum";
const isHigoOrChat = (h_app) => {
  return [hAppEnum.pro, hAppEnum.higo].includes(h_app);
};
export {
  isHigoOrChat
};
